<template>
  <div>
    <TrackerLine v-for="name in trackerNames"
                 :key="name"
                 :loadingTrackers="loadingTrackers"
                 :trackerName="name"
                 :trackerCount="trackerCounts[name]"
                 :iconName="trackerIcons[name]"
                 :iconColor="trackerColors[name]"/>
  </div>
</template>

<script>
import TrackerLine from './TrackerLine';

export default {
  name: 'NoloStats',
  components: {TrackerLine},
  data() {
    return {
      loadingTrackers: false,
      trackerNames: ['physical', 'mental', 'calls'],
      trackerIcons: {
        'physical':'fa-fist-raised',
        'mental':'fa-brain',
        'calls':'fa-phone-alt',
      },
      trackerColors: {
        'physical':'dodgerblue',
        'mental':'indianred',
        'calls':'forestgreen',
      },
      trackerCounts: {}
    }
  },
  created() {
    /* eslint-disable no-console */
    this.loadingTrackers = true;
    let getTrackersUrl =
      'https://noi3mg9y29.execute-api.us-east-1.amazonaws.com/prod/getTrackers';
    this.axios
      .post(getTrackersUrl, {"tracker_names": this.trackerNames})
      .then(response => {
        console.log(response);
        this.trackerCounts = response.data.response;
      })
      .catch(response => {
        console.log(response);
      })
      .finally(() => {this.loadingTrackers = false})
    /* eslint-enable no-console */
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
